import { LayoutController } from "onearm";
import gsap from "gsap";
import { formatCurrency } from "../../utils/formatCurrency.js";

export class InfoDisplay extends LayoutController {
    init() {
        this._currentBalance = 0;
        this._currentBet = 0;
        this._currentWin = 0;
        this._balanceTween = null;
        this._winTween = null;
        this._currency = this.options.currency || "";
        this._winContainer = this.find("win");
        this._winValueText = this.find("win.value");
    }

    setBalance(value) {
        this._killTween("_balanceTween");
        this._currentBalance = Number(value);
        this._updateText("BalanceText", this._currentBalance);
    }

    setBet(value) {
        this._currentBet = Number(value);
        this._updateText("BetText", this._currentBet);
    }

    setWin(value) {
        this._killTween("_winTween");
        this._currentWin = Number(value);
        this._updateText("WinText", this._currentWin);
    }

    animBalance(value) {
        this._animateField("BalanceText", "_balanceTween", "_currentBalance", value, 0.5);
    }

    showWin() {
        if (this._winContainer) this._winContainer.visible = true;
    }

    hideWin() {
        if (this._winContainer) this._winContainer.visible = false;
    }

    resetWin() {
        this._killTween("_winTween");
        this._currentWin = 0;
        this._updateText("WinText", 0);
        this.hideWin();
    }

    addWin(delta) {
        const target = this._currentWin + Number(delta);
        this._animateField("WinText", "_winTween", "_currentWin", target, 0.4);
    }

    _animateField(textName, tweenKey, valueKey, targetValue, duration) {
        this._killTween(tweenKey);
        const target = { val: this[valueKey] };
        this[tweenKey] = gsap.to(target, {
            val: Number(targetValue),
            duration,
            ease: "none",
            onUpdate: () => {
                this[valueKey] = target.val;
                this._updateText(textName, target.val);
            },
            onComplete: () => {
                this[tweenKey] = null;
            },
        });
    }

    _updateText(name, value) {
        const formatted = formatCurrency(value, this._currency);
        if (name === "WinText") {
            if (this._winValueText) this._winValueText.text = formatted;
            return;
        }
        this.forAll(name, (text) => {
            text.text = formatted;
        });
    }

    _killTween(tweenKey) {
        if (this[tweenKey]) {
            this[tweenKey].kill();
            this[tweenKey] = null;
        }
    }

    getState() {
        return {
            balance: this._currentBalance,
            bet: this._currentBet,
            win: this._currentWin,
        };
    }

    setState(state) {
        if (state.balance !== undefined) this.setBalance(state.balance);
        if (state.bet !== undefined) this.setBet(state.bet);
        if (state.win !== undefined) this.setWin(state.win);
    }

    onDestroy() {
        this._killTween("_balanceTween");
        this._killTween("_winTween");
    }
}
